export const bailiffDocumentAllSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentAll;
export const bailiffDocumentOpenAddSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentOpenAdd;
export const bailiffDocumentOpenEditSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentOpenEdit;
export const bailiffDocumentSelectedSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentSelected;
export const bailiffDocumentSearchSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentSearch;
export const bailiffDocumentDetailSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentDetail;
export const bailiffDocumentRawSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentRaw;
//
export const bailiffDocumentSortSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentSort;
//

export const bailiffDocumentOpenPaySelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentOpenPay;
export const bailiffDocumentOpenUploadSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentOpenUpload;
export const bailiffDocumentStepSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentStep;
export const bailiffDocumentExtractingCountSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentExtractingCount;
export const bailiffDocumentPercentUploadSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentPercentUpload;
export const bailiffDocumentPercentProcessSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentPercentProcess;
export const bailiffDocumentAudioSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentAudio;
export const bailiffDocumentAudioDurationSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentAudioDuration;
export const bailiffDocumentUploadCompleteSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentUploadComplete;
export const bailiffDocumentProcessCompleteSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentProcessComplete;

//DEPOSIT.
export const bailiffDocumentDepositJobIdSelector = (state) =>
  state?.bailiffDocumentReducer?.bailiffDocumentDepositJobId;
